import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  message,
  Modal,
  Dropdown,
  Menu,
  Card,
  Form,
  Input,
  Row,
  Col,
  Button,
  Pagination,
} from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import {
  addMake,
  editMake,
  removeMake,
} from '../../../store/actions/vehicleMakes-actions';

const VehicleMakes = ({ makes }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [openModal, setOpenModal] = useState(false);
  const [editingMake, setEditingMake] = useState(null);
  const [form] = Form.useForm();

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 30;
  const [searchTerm, setSearchTerm] = useState('');

  const handleSubmitMake = () => {
    form
      .validateFields()
      .then((values) => {
        const { makeName } = values;
        if (editingMake) {
          dispatch(
            editMake({ makeId: editingMake.id, body: { name: makeName } })
          );
        } else {
          dispatch(addMake({ name: makeName }));
        }
        form.resetFields();
        setOpenModal(false);
        setEditingMake(null);
      })
      .catch((info) => {
        message.error('Make name is required!');
      });
  };

  const handleEditMake = (make) => {
    setEditingMake(make);
    form.setFieldsValue({ makeName: make.name });
    setOpenModal(true);
  };

  const handleDeleteMake = (makeId) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this make?',
      onOk: () => dispatch(removeMake(makeId)),
    });
  };

  const menuItems = (make) => [
    {
      label: t('common.edit'),
      key: 'edit',
      icon: <EditOutlined />,
      onClick: () => handleEditMake(make),
    },
    {
      label: t('common.delete'),
      key: 'delete',
      danger: true,
      icon: <DeleteOutlined />,
      onClick: () => handleDeleteMake(make.id),
    },
  ];

  const filteredMakes = makes.filter((make) =>
    make.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedMakes = filteredMakes.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  let content = (
    <div className="container-fluid p-0">
      <Card
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <span>{t('vehicles.makes')}</span>
            <Input
              placeholder={t('common.searchByName')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ marginBottom: 16, width: 200 }}
            />
            <Button
              type="primary"
              onClick={() => {
                setOpenModal(true);
                form.resetFields();
              }}
            >
              {t('common.add')} {t('vehicles.make')}
            </Button>
          </div>
        }
        style={{ marginBottom: 16 }}
      >
        <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }}>
          {paginatedMakes.map((make) => (
            <Col key={make.id} xs={24} sm={12} md={8} lg={6} xl={6} xxl={4}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                }}
              >
                <Card style={{ flex: '1 0 auto' }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      height: '100%',
                    }}
                  >
                    <div>
                      <h3>{make.name}</h3>
                    </div>
                    <Dropdown.Button
                      style={{ zIndex: 1 }}
                      overlay={<Menu items={menuItems(make)} />}
                    />
                  </div>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={filteredMakes.length}
          onChange={(page) => setCurrentPage(page)}
          showSizeChanger={false}
          showQuickJumper
          style={{ marginTop: 16 }}
        />
      </Card>
    </div>
  );

  return (
    <>
      {content}
      <Modal
        title={
          editingMake
            ? t('common.edit') + ' ' + t('vehicles.make')
            : t('common.add') + ' ' +  t('vehicles.make')
        }
        open={openModal}
        onCancel={() => {
          setOpenModal(false);
          setEditingMake(null);
        }}
        onOk={handleSubmitMake}
        okText={t('common.ok')}
        cancelText={t('common.cancel')}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="makeName"
            label={t('common.name')}
            rules={[
              {
                required: true,
                message: t('form.validationMessages.requiredField', {
                  field: t('common.name'),
                }),
              },
            ]}
          >
            <Input placeholder="Enter make name" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default VehicleMakes;
